import React from "react";
import {
  Box,
  Snackbar,
  Alert,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  IconButton,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ReceiptIcon from "@mui/icons-material/Receipt";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import Pagination from "../../Pagination";
import FormatTime from "../../AdsPage/FormatTime";
import {
  cardOutline,
  fonts,
  headingFonts,
  noOutline,
} from "../../../Styles/Styles";

export default function AllAdsList({
  handleMarkAsSoldOrNot,
  handleDelete,
  handleEdit,
  handleViewOffers,
  handleViewAd,
  ads,
  error,
  loading,
  successMessage,
  handleCloseSnackbar,
  currentPage,
  totalPages,
  handlePageChange,
  isDeletedAdsPage,
}) {
  return (
    <Box>
      {error && (
        <Snackbar
          open={Boolean(error)}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
        >
          <Alert onClose={handleCloseSnackbar} severity="error">
            {error}
          </Alert>
        </Snackbar>
      )}
      {successMessage && (
        <Snackbar
          open={Boolean(successMessage)}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
        >
          <Alert onClose={handleCloseSnackbar} severity="success">
            {successMessage}
          </Alert>
        </Snackbar>
      )}
      <TableContainer sx={{ ...cardOutline }}>
        <Table aria-label="ads table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ ...headingFonts }}>Title</TableCell>
              <TableCell sx={{ ...headingFonts }}>Category</TableCell>
              <TableCell sx={{ ...headingFonts }}>Price</TableCell>
              <TableCell sx={{ ...headingFonts }}>Status</TableCell>
              <TableCell sx={{ ...headingFonts }}>
                {isDeletedAdsPage ? "Deletion Date" : "Created Date"}
              </TableCell>
              <TableCell sx={{ ...headingFonts }}>Offers</TableCell>
              <TableCell sx={{ ...headingFonts }}>Views</TableCell>
              {!isDeletedAdsPage && (
                <TableCell sx={{ ...headingFonts }}>Actions</TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {ads.length === 0 && !loading ? (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ ...fonts }}>
                  No ads found.
                </TableCell>
              </TableRow>
            ) : (
              ads.map((ad) => (
                <TableRow key={ad._id}>
                  <TableCell
                    onClick={() => handleViewAd(ad.uniqueId)}
                    sx={{ ...headingFonts, cursor: "pointer" }}
                  >
                    {ad.title}
                  </TableCell>
                  <TableCell sx={{ ...fonts }}>{ad.category}</TableCell>
                  <TableCell
                    sx={{ ...fonts }}
                  >{`$${ad.price.toLocaleString()}`}</TableCell>
                  <TableCell sx={{ ...fonts }}>
                    {ad.isSold ? "Sold" : "Available"}
                  </TableCell>
                  <TableCell sx={{ ...fonts }}>
                    <FormatTime createdAt={ad.createdAt} />
                  </TableCell>
                  <TableCell sx={{ ...fonts }}>{ad.offersCount}</TableCell>
                  <TableCell sx={{ ...fonts }}>{ad.views}</TableCell>
                  {!isDeletedAdsPage && (
                    <TableCell sx={{ ...fonts }}>
                      {/* View Offers */}
                      <Tooltip title="View Offers" arrow>
                        <IconButton
                          onClick={() => handleViewOffers(ad.uniqueId)}
                          sx={{
                            color: "var(--primary-color)",
                            ...noOutline,
                          }}
                        >
                          <ReceiptIcon />
                        </IconButton>
                      </Tooltip>

                      {/* Edit Ad */}
                      <Tooltip title="Edit" arrow>
                        <IconButton
                          onClick={() => handleEdit(ad.uniqueId)}
                          sx={{
                            color: "var(--primary-color)",
                            ...noOutline,
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>

                      {/* Delete Ad */}
                      <Tooltip title="Delete" arrow>
                        <IconButton
                          onClick={() => handleDelete(ad._id)}
                          color="error"
                          sx={{
                            ...noOutline,
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>

                      {/* Mark as Sold / Not Sold */}
                      <Tooltip
                        title={ad.isSold ? "Mark as Not Sold" : "Mark as Sold"}
                        arrow
                      >
                        <IconButton
                          onClick={() =>
                            handleMarkAsSoldOrNot(ad.uniqueId, ad.isSold)
                          }
                          color={ad.isSold ? "secondary" : "warning"}
                          sx={{ ...noOutline }}
                        >
                          {ad.isSold ? <CancelIcon /> : <CheckCircleIcon />}
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  )}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      {totalPages > 1 && (
        <Box sx={{ mt: 6, display: "flex", justifyContent: "center" }}>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </Box>
      )}
    </Box>
  );
}
